import { KeyboardArrowRightOutlined } from '@mui/icons-material'
import { Box, Typography } from '@mui/material'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import AccordionCommon from 'src/components/AccordionCommon'
import { IComponentFilters, IProductWithComponents } from 'src/generated-types'
import ComponentsTable from './ComponentsTable'

interface IProductDetailAccordionProps {
  customerId: EntityId
  localityId: EntityId
  mooringId: EntityId
  product: IProductWithComponents
  localityName?: string
  filters: IComponentFilters
  isBatchNumberEditable?: boolean
}
const ProductDetailAccordion: React.FC<IProductDetailAccordionProps> = ({
  customerId,
  localityId,
  mooringId,
  product,
  localityName,
  filters,
  isBatchNumberEditable,
}) => {
  const { t } = useTranslation('component-overview')
  const [expanded, setExpanded] = useState(false)
  return (
    <>
      <AccordionCommon
        title={
          <Box>
            <Box display={'flex'} flexDirection={'row'} gap={0.5}>
              <Typography>{`${t('articleNumber', { ns: 'component' })}:`}</Typography>
              <Typography fontWeight={500}>{product.articleNumber}</Typography>
            </Box>
            <Box display={'flex'} flexDirection={'row'} gap={0.5}>
              <Typography>{`${t('articleName', { ns: 'component' })}:`}</Typography>
              <Typography fontWeight={500}>{product.articleName}</Typography>
            </Box>
            <Box display={'flex'} flexDirection={'row'} gap={0.5}>
              <Typography>{`${t('count', { ns: 'component' })}:`}</Typography>
              <Typography fontWeight={500}>{product.count}</Typography>
            </Box>
          </Box>
        }
        key={product.productId}
        expandedIcon={
          <Box width={'50px'} height={'50px'} display={'flex'} alignItems={'center'} justifyContent={'center'}>
            <KeyboardArrowRightOutlined fontSize="small" />
          </Box>
        }
        border="0px"
        removeBoxShadow
        accordionHeight={'64px'}
        onChange={() => setExpanded(!expanded)}
      >
        <Box paddingLeft={-3}>
          {expanded && (
            <ComponentsTable
              customerId={customerId}
              localityId={localityId}
              mooringId={mooringId}
              productId={product.productId}
              localityName={localityName}
              filters={filters}
              isBatchNumberEditable={isBatchNumberEditable}
            />
          )}
        </Box>
      </AccordionCommon>
    </>
  )
}

export default ProductDetailAccordion
